import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import Link from '@atlaskit/link';
import { isIsolatedCloud } from '../utilities/env';
import { checkFeatureGate } from '../utilities/feature-flags/feature-gate';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';

const ReCaptchaContainer = styled.div`
  margin-top: ${gridSize()}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const RecaptchaNotice = () => {
  const { formatMessage } = useIntl();

  if (checkFeatureGate(AidFrontendFeatureGate.DISABLE_IC_RECAPTCHA_TC) && isIsolatedCloud()) {
    return null;
  }

  return (
    <FormattedMessage
      id="signup.form.recaptcha.notice.xml"
      defaultMessage="This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply."
      values={{
        'google-pp-link': chunks => (
          <Link
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer noopener"
            aria-label={formatMessage({
              id: 'signup.form.recaptcha.notice.google.pp.link.aria.label',
              defaultMessage: 'Google Privacy Policy',
              description:
                "Aria label for link to let users learn more about Google's Privacy Policy.",
            })}>
            {chunks}
          </Link>
        ),
        'google-tos-link': chunks => (
          <Link
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noreferrer noopener"
            aria-label={formatMessage({
              id: 'signup.form.recaptcha.notice.google.tos.link.aria.label',
              defaultMessage: 'Google Terms of Service',
              description:
                "Aria label for link to let users learn more about Google's Terms of Service.",
            })}>
            {chunks}
          </Link>
        ),
      }}
    />
  );
};

export default ReCaptchaContainer;
